import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const Tawk: React.FC<Pick<CheckoutComponentChatAttibutesType, "accountId">> = ({
  accountId,
}) => {
  const script = `
    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    (function(){
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='${accountId}';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin','*');
    s0.parentNode.insertBefore(s1,s0);
    })();
  `;

  return (
    <Helmet>
      <script type="text/javascript">{script}</script>
    </Helmet>
  );
};

export default Tawk;
